import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './campaign_balance.less'
import { getI18n } from 'client/i18n'
import { BodyText, Tooltip } from '@paypalcorp/pp-react'
import { formatMoney } from 'client/griffin'
import Separator from 'components/common/separator'

const i18n = getI18n('components/campaign_balance')

class campaign_balance extends React.Component {
  static propTypes = {
    pledge: PropTypes.number,
    withdraw: PropTypes.number,
    campaignId: PropTypes.string,
    currencyCode: PropTypes.string,
    moneyboxAmount: PropTypes.number,
    removeTrailingZeros: PropTypes.bool,
    netAmount: PropTypes.number,
  }

  static defaultProps = {
    removeTrailingZeros: false,
  }

  render() {
    const {
      currencyCode,
      moneyboxAmount,
      netAmount,
      pledge,
      removeTrailingZeros,
    } = this.props
    return (
      <div styleName="balance-wrapper">
        <BodyText strong>{i18n('donations')}</BodyText>

        <Separator />

        <div styleName="balance">
          <div styleName="amount-row">
            <div styleName="label">
              <BodyText>{i18n('amount_received')}</BodyText>
              <Tooltip
                name="amount_received_info"
                description={i18n('amount_tooltip_1')}
              />
            </div>
            <div styleName="value">
              {formatMoney(currencyCode, netAmount, {
                removeTrailingZeros,
              })}
            </div>
          </div>
          <div styleName="amount-row">
            <div styleName="label">
              <BodyText>{i18n('available')}</BodyText>
              <Tooltip
                name="available_balance_info"
                description={i18n('available_tooltip')}
              />
            </div>
            <div styleName="value">
              {formatMoney(currencyCode, moneyboxAmount, {
                removeTrailingZeros,
              })}
            </div>
          </div>
          <div styleName="pledge-row">
            <div styleName="label">
              <BodyText strong>{i18n('pledge_by')}</BodyText>
            </div>
            <div styleName="value">
              {formatMoney(currencyCode, pledge, {
                removeTrailingZeros,
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default cssModules(campaign_balance, styles)
